import React from 'react'
import Plot from 'react-plotly.js';

interface Props {
    countries: Array<string>
    values: Array<number>
}

export const ScatterGeoChart = ({ countries, values }: Props) => {
    var layout = {
        'geo': {
            'resolution': 50,
            showland: true,
            landcolor: 'rgb(217, 217, 217)',
            subunitwidth: 1,
            countrywidth: 1,
            subunitcolor: 'rgb(255,255,255)',
            countrycolor: 'rgb(255,255,255)'
        },
        height: 300,
        margin: {
            b: 0,
            t: 0,
            r: 0,
            l: 0,
            autoexpand: false,
        },

    };
    return (
        <Plot
            data={[{
                type: 'scattergeo',
                mode: 'markers',
                locationmode: "country names",
                locations: countries,
                customdata: values,
                marker: {
                    size: values,
                    sizeref: 2.0 * Math.max(...values) / (10 ** 2),
                    sizemin: 5,
                    cmin: 0,
                    cmax: 50,
                    line: {
                        color: 'black'
                    }
                },
                hovertemplate: "%{location}: %{customdata} users",

                name: ''
            }]}
            layout={layout}
            useResizeHandler={true}
            style={{ width: "100%", height: "100%" }}
        />
    )
}